module.exports = __webpack_public_path__ + "static/22-5704c512243dac8b4f9d8605a96b4321.jpeg";